import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  DialogBody,
  SearchBar,
  GeneralTableBox,
  PaginationTable,
  ActionIconButton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

// Diálogo específico para tipos de cuotas
import FeeTypeDialog from '../dialogs/FeeTypeDialog';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';

const ITEMS_PER_PAGE = 5;

const filterFeeTypes = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();
  return collection.filter((type) => type.name?.toLowerCase().includes(normalized));
};
/**
 * Tab de tipos de cuotas refactorizada siguiendo los patrones del proyecto
 */
const FeeTypesTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedFeeTypes,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterFeeTypes,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <CustomButton variant="contained" onClick={handleAdd}>
          <PostAddIcon sx={{ mr: 1 }} />
          Agregar
        </CustomButton>
        <SearchBar onSearch={handleSearch} />
      </Box>
      <GeneralTableBox>
        <Table>
          <TableHead>
            <TableRow>
              <HeadTableCell>Nombre</HeadTableCell>
              <HeadTableCell>Tipo</HeadTableCell>
              <HeadTableCell>Completa</HeadTableCell>
              <HeadTableCell>Puntaje</HeadTableCell>
              <HeadTableCell>Acciones</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedFeeTypes.map((fee, index) => (
              <TableRow key={fee.id || index}>
                <RowTableCell>{fee.name}</RowTableCell>
                <RowTableCell>{fee.feeType}</RowTableCell>
                <RowTableCell>{fee.complete === 1 ? 'Si' : 'No'}</RowTableCell>
                <RowTableCell>{fee.score ? 'Si' : 'No'}</RowTableCell>
                <RowTableCell>
                  <ActionIconButton variant="edit" onClick={() => handleEdit(fee)} />
                  <ActionIconButton variant="delete" onClick={() => handleDelete(fee.uuid)} />
                </RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {totalCount > rowsPerPage && (
          <PaginationTable
            totalPages={totalPages}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalCount={totalCount}
          />
        )}
      </GeneralTableBox>

      <FeeTypeDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default FeeTypesTab;
